import { render, staticRenderFns } from "./MFA.vue?vue&type=template&id=9ce1d218"
import script from "./MFA.vue?vue&type=script&lang=js"
export * from "./MFA.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports